import { ContainerModule } from 'inversify';
import { DslRuntimeModule, DslRuntimeModuleSymbol } from '@xlearn/common';
import { ExamDslRuntimeModule } from './exam-dsl-runtime-module'

export const examDslRuntimeModule = new ContainerModule((bind) => {
  bind<DslRuntimeModule>(DslRuntimeModuleSymbol).to(ExamDslRuntimeModule);
});
